import {isNoU} from "../utils/DBUtils";
import lifecycle from "recompose/lifecycle";
import compose from 'recompose/compose';
import {connect} from "react-redux";
import {toggleSectionScroll} from "scroll/actions";
import {bindActionCreators} from "redux";
import {withRouter} from "react-router";

const mapStateToProps = (state, ownProps) => {
    let shouldScroll = false;

    if (!isNoU(state.scroll.scrollToSection) && state.scroll.scrollToSection === ownProps.id) {
        shouldScroll = true;
    }

    return {
        shouldScroll: shouldScroll
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    toggleSectionScroll: toggleSectionScroll
}, dispatch);

const Connected = connect(mapStateToProps, mapDispatchToProps);

const Lifecycle = lifecycle({
    componentDidUpdate() {
        // Only if we have to, should be only once per section toggle
        if (this.props.shouldScroll === true) {
            let scrollToEle = document.getElementById(this.props.id);
            if (!isNoU(scrollToEle)) {
                // offset from top of page, not window
                let top = scrollToEle.offsetTop;
                let topBarOffset = 70; // Size of fixed nav bar, need a way so this isn't hard coded and shared between css and js
                let scrollBy = top - topBarOffset;

                const scrollOnNextTick = () => setTimeout(() => {
                    window.scrollTo(0, scrollBy);
                    this.props.toggleSectionScroll();
                }, 0);

                scrollOnNextTick();

                // in case page was reloaded
                window.addEventListener('load', scrollOnNextTick, false);
            } else {
                console.warn(`attempted to scroll to element that hasn't mounted ${this.props.id}`);
            }
        }
    }
});

export const scrollListener = (Component) => compose(
    withRouter,
    Connected,
    Lifecycle
)(Component);



// WEBPACK FOOTER //
// ./public/hoc/ScrollListenerAccordion.js